import { FilterHandler } from './FilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';

export abstract class AbstractFilterHandler implements FilterHandler {
    private nextHandler: FilterHandler;

    public setNext(handler: FilterHandler): FilterHandler {
        this.nextHandler = handler;
        return handler;
    }

    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        if (this.nextHandler) {
            // console.log('AbstractFilterHandler->handle next');
            return this.nextHandler.handle(data, filterOptions);
        }
        // console.log('AbstractFilterHandler->handle finished - return data');
        return data;
    }
}
